import { IAMAPI } from '../iam/API'
import { GetCurrentUser } from '../iam/SessionStore'
import { computed } from 'mobx'

/**
 * Manages multi-factor authentication
 */
export default class MultiFactorAuthStore {
  /**
   * Constructor.
   */
  constructor(private iamAPI: IAMAPI, private getCurrentUser: GetCurrentUser) {}

  /**
   * Determine whether the user is enrolled in multi-factor authentication.
   */
  @computed
  get isUserEnrolled() {
    return this.getCurrentUser().multiFactorAuthenticationEnabled
  }

  /**
   * Gets an MFA enrollment URL.
   */
  getEnrollmentUrl() {
    return this.iamAPI.auth.enrollMFA().then((r) => r.enrollment_url)
  }
}
